/* eslint-disable */
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { applyMiddleware, createStore, compose } from 'redux';
import thunkMiddleware from 'redux-thunk';
import { BrowserRouter } from 'react-router-dom';
import NunitoSans from 'typeface-nunito-sans';
import moment from 'moment';
import { ReactTableDefaults } from 'react-table'

import App from './App.jsx';
import rootReducer from './reducers';
import registerServiceWorker from './registerServiceWorker';

// Set moment's default format for displaying dates
moment.defaultFormat = 'DD-MM-YYYY';

// Override React Table defaults
ReactTableDefaults.expanderDefaults = {
  ...ReactTableDefaults.expanderDefaults,
  style: {
    display: 'none',
  },
  headerStyle: {
    display: 'none',
  }
}

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const store = createStore(
  rootReducer,
  composeEnhancers(
    applyMiddleware(
      thunkMiddleware,
    ),
  ),
);

ReactDOM.render(
  <BrowserRouter>
    <Provider store={store}>
      <App />
    </Provider>
  </BrowserRouter>,
  document.getElementById('root'),
);
registerServiceWorker();



// WEBPACK FOOTER //
// ./client/src/index.js